import { useTranslation } from 'react-i18next';
import { ConfirmDialog } from '@bliks-io/ui';

interface MergeAssignmentConfirmDialogProps {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  stepName: string;
  isMerging: boolean;
  onConfirm: () => void;
}

export function MergeAssignmentConfirmDialog({
  open,
  onOpenChange,
  stepName,
  isMerging,
  onConfirm
}: MergeAssignmentConfirmDialogProps) {
  const { t } = useTranslation();
  return (
    <ConfirmDialog
      open={open}
      onOpenChange={onOpenChange}
      title={t('assignmentReview.mergeConfirmTitle')}
      description={t('assignmentReview.mergeConfirmDescription', { stepName })}
      confirmLabel={t('assignmentReview.mergeConfirm')}
      cancelLabel={t('assignmentReview.mergeCancel')}
      onConfirm={onConfirm}
      isPending={isMerging}
    />
  );
}
